import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { withRouter } from "react-router";
import {
    Card,
    Page,
    Text,
    // TextField,
    IndexTable,
    IndexFilters,
    // useSetIndexFiltersMode,
    useIndexResourceState,
    ChoiceList,
    // RangeSlider,
    Badge,
    // useBreakpoints,
    BlockStack,
    Icon,
    Button,
    Tooltip,
    ActionList,
    Popover,
    Modal,
    Pagination,
    Spinner,
    Banner,
    // ProgressBar,
    Checkbox,
    TextField,
} from "@shopify/polaris";
import {
    BlogIcon,
    XIcon,
    DeleteIcon,
    DuplicateIcon,
    EditIcon,
    LockIcon,
    RefreshIcon,
    SaveIcon,
    ViewIcon,
    WandIcon,
} from "@shopify/polaris-icons";
import "./index.scss";
import {
    reqGetKeywordsData,
    reqGetKeywordsListData,
    reqSaveCategory,
    reqUnlockKeywordsPosition,
    reqGetExportRecord,
    reqExportKeywords,
    reqHandleAIUsagePayment,
    reqGetBlogProgress,

} from "../../../api/index";
import Langauge from "../../../i18n/Language";
import FooterPageSelect from "../../../components/FooterPageSelect/indexPage";
import FooterTrustHelp from "../../../components/FooterTrustHelp";
import utils from "../../../utils/utils";
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { API_OSS } from "../../../utils/constants";
import AddToSegments from "../../../components/AddToSegments";
import SkeltonLoading from "../../../components/SkeltonLoading";
import UnfinishedBlogModal from "../../../components/UnfinishedBlogModal";
//轮播图
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination as S_Pagination, Navigation } from "swiper/modules";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Langauge;

const KeywordsData = (props) => {
    const {
        level,

        toggleToast,
        openUpdateLimit,
    } = props;
    const resourceName = {
        singular: t("data"),
        plural: t("data"),
    };

    const testData = [
        { "id": 1, "keyword": "****" },
        { "id": 2, "keyword": "****" },
        { "id": 3, "keyword": "****" },
        { "id": 4, "keyword": "****" },
        { "id": 5, "keyword": "****" },
        { "id": 6, "keyword": "****" },
    ];

    const listRef = useRef();
    const jumpBlogIdRef = useRef(-1);

    const [pageLoading, setPageLoading] = useState(true);
    const [embedLoading, setEmbedLoading] = useState(true);
    const [userLevel, setUserLevel] = useState(0);
    const [notFirstReq, setNotFirstReq] = useState(false);  // 首次请求
    // 分页数据
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [current_PageSize, setCurrentPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [hasNext, setHasNext] = useState(false);
    // 列表数据
    const [tableData, setTableData] = useState([]);
    const [listLoading, setListLoading] = useState(true);
    // const [keywords_ranking_use, setKeywordsRankingUse] = useState(0);
    // const [keywords_ranking_all, setKeywordsRankingAll] = useState(0);
    // const [keywordsRankingPerc, setKeywordsRankingPerc] = useState(0);

    // 顶部模块数据
    // const [covered, setCovered] = useState(0);
    // const [coveredAll, setCoveredAll] = useState(0);
    // const [coveredPerc, setCoveredPerc] = useState(0);
    const [kwTen, setKWTen] = useState(0);
    const [kwTenPerc, setKWTenPerc] = useState(0);
    const [kwOneHundred, setKWOneHundred] = useState(0);
    const [kwOneHundredPerc, setKWOneHundredPerc] = useState(0);
    const [traffic, setTraffic] = useState(0);
    const [trafficPerc, setTrafficPerc] = useState(0);
    // const [updTime, setUpdTime] = useState(0);

    // 导出记录
    const [exportRecordsData, setExportRecordsData] = useState([]);  // 导出记录
    // 网站数据
    // const [websiteArray, setWebsiteArray] = useState([]);

    const [getRecordState, setGetRecordState] = useState(false);  // 导出记录获取状态
    const [recordLoading, setRecordLoading] = useState(false);  // 导出记录状态
    const [exportRecordsState, setExportRecordsState] = useState(false);  // 导出记录弹窗
    const [refreshLoading, setRefreshLoading] = useState(false);  // 刷新状态
    const [exportPopState, setExportPopState] = useState(false);  // 导出弹层
    const [exportLoading, setExportLoading] = useState(false);  // 导出状态
    // const [topicPopState, setTopicPopState] = useState(false);  // Topic弹层
    // const [topicList, setTopicList] = useState([]);  // Topic列表
    // const [topicSel, setTopicSel] = useState({});  // Topic选项
    const [topicSelArr, setTopicSelArr] = useState([]);  // Topic筛选选项
    const [segmentsList, setSegmentsList] = useState([]);  // Segments选项
    const [coveredSelArr, setCoveredSelArr] = useState([]);  // Covered筛选选项
    const [typeSelArr, setTypeSelArr] = useState([]);  // Type筛选选项
    const [segmentsSelArr, setSegmentsSelArr] = useState([]);  // Segments筛选选项
    const [isShowSegDel, setIsShowSegDel] = useState(false);  // Segments删除按钮
    const [openState, setOpenState] = useState(false);  // 添加分类
    const [keywordsSelData, setKeywordsSelData] = useState([]);  // 选择id数组
    const [isShowCategoryModal, setIsShowCategoryModal] = useState(false);  // 分类管理状态
    const [kdSelArr, setKdSelArr] = useState([]);
    const [generatingTipState, setGeneratingTipState] = useState(false); // 正在生成提示弹窗
    const [recordData, setRecordData] = useState({}); // 记录数据
    const [businessData, setBusinessData] = useState({}); // 业务数据
    const [recordId, setRecordId] = useState(-1); // 记录ID


    // 额度
    const [ai_usage_status, setAiUsageStatus] = useState(-1);  // 超额状态
    const [AiPoints, setAiPoints] = useState(0);  // 超额状态
    const [agreeLoading, setAgreeLoading] = useState(false);  // 超额状态
    const [buyAiCreditsState, setBuyAiCreditsState] = useState(false);  // 超额状态
    const [writeLoading, setWriteLoading] = useState(-1);  // 超额

    // const [writePopState, setWritePopState] = useState(-1);  // 按钮弹层
    // const [viewPopState, setViewPopState] = useState(-1);  // view弹层
    const [delSegState, setDelSegState] = useState(false);  // 删除seg弹层
    const [delSegData, setDelSegData] = useState({});  // 删除seg数据
    const [delSegLoading, setDelSegLoading] = useState(false);  // 删除seg 状态
    const [createSegmentState, setCreateSegmentState] = useState(true);  // 创建模式
    const [segmentVal, setSegmentVal] = useState("");  // seg文案
    const [createLoading, setCreateLoading] = useState(false);  // 创建loading
    const [editSegId, setEditSegId] = useState(-1);  // 操作对象
    const [categoryVal, setCategoryVal] = useState('');  // 操作对象
    const [updDisabled, setUpdDisabled] = useState(false);

    const [websiteLoading, setWebsiteLoading] = useState(false);  // 获取网站状态
    const [unlockId, setUnlockId] = useState([]);  // 解锁对象状态
    const [hoverReid, setHoverReid] = useState(-1);  // 解锁对象状态
    // const [glassId, setGlassId] = useState(-1);  // icon状态

    // 提示模块
    const [pageTipBanner, setPageTipBanner] = useState({ msg: '', tone: '' });
    const [activeBoxAudit, setActiveBoxAudit] = useState(true);
    const [domainNotResolve, setDomainNotResolve] = useState(false);    // 域名未解析
    const [resolveUrl, setResolveUrl] = useState('');
    const [isGetData, setIsGetData] = useState(false);
    const [isShowTipBanner, setIsShowTipBanner] = useState(true);

    const [selected, setSelected] = useState(0);
    const [queryValue, setQueryValue] = useState("");
    const [sortSelected, setSortSelected] = useState(["data asc"]);
    const [mode, setMode] = useState("DEFAULT"); // DEFAULT || FILTERING 

    // 排序
    const [kdSort, setKdSort] = useState('descending');
    const [volumeSort, setVolumeSort] = useState('descending');
    const [trafficSort, setTrafficSort] = useState('descending');

    const pageRef = useRef(page);
    const sizeRef = useRef(size);
    const sortInxRef = useRef(-1);
    const sortTypeRef = useRef('');
    const KdDegreeRef = useRef(kdSelArr);
    const coveredSelRef = useRef(coveredSelArr);
    const segmentsSelRef = useRef(segmentsSelArr);
    const typeSelRef = useRef(typeSelArr);
    const keywordSelRef = useRef('');

    // 标题
    const tableHeadings = [
        { id: 1, title: <span>{t("Keyword")}</span> },
        { id: 2, title: <Tooltip content={t("Estimated difficulty of ranking in the top 10 organic search results for this keyword on a 100-point scale")}><span>{t("KD")}</span></Tooltip>, defaultSortDirection: kdSort },
        { id: 3, title: <Tooltip content={t("This keyword has been searched for this time in the past 12 months")}><span>{t("Volume")}</span></Tooltip>, defaultSortDirection: volumeSort },
        { id: 4, title: <Tooltip content={t("An estimation of the number of monthly visitors that your target gets from organic search for a keyword. We base this on the number of searches for that keyword over the latest month.")}><span>{t("Traffic")}</span></Tooltip>, defaultSortDirection: trafficSort },
        { id: 5, title: <span>{t("Position")}</span> },
        { id: 6, title: <Tooltip content={t("The URL that is ranking in organic search results. If there are multiple URLs ranking for a single keyword, we show the top URL.")}><span>{t("URL")}</span></Tooltip> },
        { id: 7, title: <span>{t("Action")}</span> },
    ]

    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(tableData);


    // 升级弹窗
    const upgradeShow = (e, v = false) => {
        props.upgradeModal(e, 'MyKeywords', 'keywords_rank_tracker', v);
    }

    // 获取生成进度
    const getBlogProgress = async () => {
        const res = await reqGetBlogProgress();
        if (res.ack === 1) {
            let _t = res.data;
            setBusinessData(_t?.business_data || {});
            setRecordData(_t?.record || {});
            setRecordId(_t?.record?.id || -1);
        }
        return res;
    }

    // 获取关键词数据
    const getKeywordData = async (cache = null, isJumpBlog = false) => {
        const res = cache || (await reqGetKeywordsData());
        if (res.ack === 1) {
            let _t = res.data;
            // let topic = [
            //     { label: 'Enabled', value: 'enabled' },
            //     { label: 'Not invited', value: 'not invited' },
            //     { label: 'Invited', value: 'invited' },
            //     { label: 'Declined', value: 'declined' },
            // ]
            // let newTopicArr = topic.map(i => {
            //     return {
            //         label: i.label,
            //         value: i.value,
            //     }
            // })
            // setTopicList(newTopicArr);
            let newSegmentsArr = (_t.category || []).map(i => {
                return {
                    id: i.id,
                    label: i.name,
                    value: i.id,
                    status: segmentsSelArr.includes(i.id) ? true : false,
                    keyword_count: i.keyword_count,
                }
            })
            setSegmentsList(newSegmentsArr);

            let _c = _t.count;
            // setCovered(_c.now.cover_num);
            // setCoveredAll(_c.total);
            setKWTen(_c.now.kw_top_10_num);
            setTraffic(_c.now.kw_top_100_volume_sum);
            setKWOneHundred(_c.now.kw_top_100_num);
            // setCoveredPerc(_c.past.cover_num === 0 ? (_c.now.cover_num === 0 ? 0 : 99) : Number(((_c.now.cover_num - _c.past.cover_num) / _c.past.cover_num) * 100).toFixed(1));
            setKWTenPerc(_c.past.kw_top_10_num === 0 ? (_c.now.kw_top_10_num === 0 ? 0 : 99) : Number(((_c.now.kw_top_10_num - _c.past.kw_top_10_num) / _c.past.kw_top_10_num) * 100).toFixed(1));
            setTrafficPerc(_c.past.kw_top_100_volume_sum === 0 ? (_c.now.kw_top_100_volume_sum === 0 ? 0 : 99) : Number(((_c.now.kw_top_100_volume_sum - _c.past.kw_top_100_volume_sum) / _c.past.kw_top_100_volume_sum) * 100).toFixed(1));
            setKWOneHundredPerc(_c.past.kw_top_100_num === 0 ? (_c.now.kw_top_100_num === 0 ? 0 : 99) : Number(((_c.now.kw_top_100_num - _c.past.kw_top_100_num) / _c.past.kw_top_100_num) * 100).toFixed(1));

            let _k = _t.my_keyword;
            setResolveUrl(_k.dns_url);
            // setActiveBoxAudit(!Boolean(_k.domain_status));
            setDomainNotResolve(!Boolean(_k.domain_status));
            setIsGetData(Boolean(_k.status));
            setEmbedLoading(false);
            // setUpdTime(_k.next_updated_at ? utils.formatUSATime(_k.next_updated_at) : 0);

            setAiUsageStatus(_t.ai.ai_usage_status)
            setAiPoints(_t.ai.ai_points)
            try {
                setActiveBoxAudit(!Boolean(sessionStorage.getItem('activeBoxKeyWebsite')));
            } catch (e) { }

            // 是否跳转博客
            setWriteLoading(-1);
            if (isJumpBlog) {
                jumpCreateBlog(-1, '', true);
            }
        } else {
            setTipBanner(res.msg);
        }
    }

    // 获取关键词列表
    const getKeywordsList = async (page, size, query) => {
        setListLoading(true);
        setHasPrevious(false);
        setHasNext(false);
        let params = {
            page,
            size,
            query
        }
        // if (topicSelArr && !isEmpty(topicSelArr)) {
        //     params.topic_id = topicSelArr;
        // }
        // 使用ref缓存
        const currentCoveredSel = coveredSelRef.current;
        const currentSegmentsSel = segmentsSelRef.current;
        const currentTypeSel = typeSelRef.current;
        const currentKdSel = KdDegreeRef.current;
        if (currentKdSel && !isEmpty(currentKdSel)) {
            params.kd = [];
            const kdCompare = {
                1: [70, 100],
                2: [50, 69],
                3: [30, 49],
                4: [0, 29],
            }
            currentKdSel.forEach((item) => {
                params.kd.push(kdCompare[item]);
            })
        }
        if (currentCoveredSel && !isEmpty(currentCoveredSel)) {
            params.covg = currentCoveredSel[0] === 'Yes' ? 1 : 0
        }
        if (currentSegmentsSel && !isEmpty(currentSegmentsSel)) {
            params.category_ids = currentSegmentsSel;
        }
        if (currentTypeSel && !isEmpty(currentTypeSel)) {
            params.from = currentTypeSel;
        }
        // 排序
        if (sortInxRef.current !== -1) {
            params.order_by_column = sortInxRef.current;
            params.order_by_direction = sortTypeRef.current;
        }
        const res = await reqGetKeywordsListData(params);
        if (res.ack === 1) {
            let _t = res.data;
            setTableData(_t.data);
            setTotal(_t.count);
            setHasPrevious(page > 1);
            setHasNext((page * size) < _t.count);
            setListLoading(false);
            setPageLoading(false);
            // 等级额度
            // setKeywordsRankingUse(_t.quota.keywords_ranking_use);
            // setKeywordsRankingAll(_t.quota.keywords_ranking_all);
            // let perc = (_t.quota.keywords_ranking_use / _t.quota.keywords_ranking_all) > 1 ? 100 : Number(((_t.quota.keywords_ranking_use / _t.quota.keywords_ranking_all) * 100).toFixed(0));
            // setKeywordsRankingPerc(perc);
            
            // 设置首次请求
            setNotFirstReq(true);

        } else {
            setTipBanner(res.msg);
        }
    }
    const debouncedGetKeywordsList = useMemo(() => debounce((value) => {
        setPage(1);
        setSize(10);
        setCurrentPageSize(10);
        pageRef.current = 1;
        sizeRef.current = 10;
        getKeywordsList(1, 10, value);
    }, 300), [getKeywordsList]); // 300ms 可根据需求调整

    // Topic筛选
    // const handleTopicChange = useCallback(
    //     (value) => setTopicSelArr(value),
    //     [],
    // );

    // KDDegree筛选
    const handleKDDegreeChange = useCallback(
        (value) => setKdSelArr(value),
        [],
    );

    // Covered筛选
    const handleCoveredChange = useCallback(
        (value) => setCoveredSelArr(value),
        [],
    );

    // Segments筛选
    const handleSegmenstChange = (value) => {
        let newSelArr = cloneDeep(segmentsSelArr);
        let newList = cloneDeep(segmentsList);
        if (newSelArr.indexOf(value) > -1) {
            newSelArr.splice(newSelArr.indexOf(value), 1);
        } else {
            newSelArr.push(value);
        }
        newList.forEach(i => {
            if (i.value === value) {
                i.status = !i.status;
            }
        })
        setSegmentsSelArr(newSelArr);
        setSegmentsList(newList);
    }

    // 类型筛选
    const handleTypeChange = (value) => {
        setTypeSelArr(value)
    }

    // 管理segments
    const handleManageSegments = () => {
        // setIsShowSegDel(!isShowSegDel);
        setIsShowCategoryModal(true);
    }

    // 打开弹窗
    const handleOpenDelSegment = (data) => {
        setDelSegState(true);
        setDelSegData(data);
    }

    // 删除筛选条件
    const handleTopicRemove = () => {
        setTopicSelArr([]);
    }
    const handleKDDegreeRemove = () => {
        setKdSelArr([]);
    }
    const handleCoveredRemove = () => {
        setSelected(0);
        setCoveredSelArr([]);
    }
    const handleSegmentsRemove = () => {
        setSegmentsSelArr([]);
    }
    const handleTypeRemove = () => {
        setTypeSelArr([]);
    }

    // 过滤条件    
    const KdDegree = [
        { label: t("Very hard (70-100)"), value: 1 },
        { label: t("Difficult (50-69)"), value: 2 },
        { label: t("Possible (30-49)"), value: 3 },
        { label: t("Easy (0-29)"), value: 4 },
    ]
    const CoveredList = [
        { label: t("Yes"), value: 'Yes' },
        { label: t("No"), value: 'No' },
    ]
    const TypeList = [
        { label: t("Organic keywords"), value: 1 },
        { label: t("Paid keywords"), value: 2 },
    ]
    const filters = [
        // {
        //     key: 'Topic',
        //     label: t("Topic"),
        //     filter: (
        //         <ChoiceList
        //             title={t("Topic")}
        //             titleHidden
        //             choices={topicList}
        //             selected={topicSelArr || []}
        //             onChange={handleTopicChange}
        //             allowMultiple
        //         />
        //     ),
        //     pinned: true,
        // },
        {
            key: 'KdDegree',
            label: t("KD"),
            filter: (
                <ChoiceList
                    title={t("KD")}
                    titleHidden
                    choices={KdDegree}
                    selected={kdSelArr || []}
                    onChange={handleKDDegreeChange}
                    allowMultiple
                />
            ),
            pinned: true,
        },
        {
            key: 'Covered',
            label: t("Covered"),
            filter: (
                <ChoiceList
                    title={t("Covered")}
                    titleHidden
                    choices={CoveredList}
                    selected={coveredSelArr || []}
                    onChange={handleCoveredChange}
                />
            ),
            pinned: true,
        },
        {
            key: 'Segments',
            label: t("Categories"),
            filter: (
                <div className="Segments_filter">
                    {/* <ChoiceList
                        title={t("Segments")}
                        titleHidden
                        choices={segmentsList}
                        selected={segmentsSelArr || []}
                        onChange={handleSegmenstChange}
                        allowMultiple
                    /> */}
                    {
                        segmentsList.map(seg => {
                            return (
                                <div className="flex_layout" key={seg.value} style={{ justifyContent: 'space-between' }}>
                                    <Checkbox
                                        label={seg.label}
                                        checked={segmentsSelArr.includes(seg.value)}
                                        onChange={() => handleSegmenstChange(seg.value)}
                                    />
                                    {
                                        isShowSegDel && <span className="seg_delete" onClick={() => handleOpenDelSegment(seg)}><Icon source={XIcon} tone="base" /></span>
                                    }
                                </div>
                            );
                        })
                    }
                    <Button variant="plain" disabled={segmentsList.length === 0} onClick={handleManageSegments}>
                        <span className="manage_cag">{t("Manage categories")}</span>
                    </Button>
                </div>
            ),
            pinned: true,
        },
        {
            key: 'Type',
            label: t("Type"),
            filter: (
                <ChoiceList
                    title={t("Type")}
                    titleHidden
                    choices={TypeList}
                    selected={typeSelArr || []}
                    onChange={handleTypeChange}
                    allowMultiple
                />
            ),
            pinned: true,
        }
    ];
    const appliedFilters = [];
    // if (topicSelArr && !isEmpty(topicSelArr)) {
    //     const key = 'Topic';
    //     appliedFilters.push({
    //         key: key,
    //         label: disambiguateLabel(key, topicSelArr, topicList),
    //         onRemove: handleTopicRemove,
    //     })
    // }
    if (kdSelArr && !isEmpty(kdSelArr)) {
        const key = 'KdDegree';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, kdSelArr, KdDegree),
            onRemove: handleKDDegreeRemove,
        })
    }
    if (coveredSelArr && !isEmpty(coveredSelArr)) {
        const key = 'Covered';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, coveredSelArr, CoveredList),
            onRemove: handleCoveredRemove,
        })
    }
    if (segmentsSelArr && !isEmpty(segmentsSelArr)) {
        const key = 'Segments';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, segmentsSelArr, segmentsList),
            onRemove: handleSegmentsRemove,
        })
    }
    if (typeSelArr && !isEmpty(typeSelArr)) {
        const key = 'Type';
        appliedFilters.push({
            key: key,
            label: disambiguateLabel(key, typeSelArr, TypeList),
            onRemove: handleTypeRemove,
        })
    }

    // 打开添加
    const handleOpenAddSegments = () => {
        if (userLevel !== 3) {
            upgradeShow(2);
        } else {
            setOpenState(true);
            setKeywordsSelData(selectedResources);
        }
    }

    // 更新排名信息
    const handleUpdateRankingInfo = () => {
        let selectArr = tableData.filter(item => selectedResources.includes(item.id) && Boolean(Number(item.website_count) > 0));
        let idArr = selectArr.map(item => item.id);
        clearSelection();
        handleUnlockPosition(null, idArr);
    }

    // 批量
    const promotedBulkActions = [
        {
            content: t("Update Ranking info"),
            onAction: () => handleUpdateRankingInfo(),
            disabled: updDisabled
        },
        {
            content: t("Add to categories"),
            onAction: () => handleOpenAddSegments(),
        }
    ];

    // 取消
    const onHandleCancel = () => {
        if (queryValue || topicSelArr.length > 0 || coveredSelArr.length > 0 || segmentsSelArr.length > 0 || kdSelArr.length > 0 || typeSelArr.length > 0) {
            handleFiltersClearAll();
        }
    };
    const onCreateNewView = async (value) => {
        return value;
    };
    const handleFiltersQueryChange = useCallback((value) => {
        setQueryValue(value);
        debouncedGetKeywordsList(value);
    }, []);

    // 清除过滤条件
    const handleFiltersClearAll = useCallback(() => {
        handleFiltersQueryChange("");
        handleTopicRemove();
        handleCoveredRemove();
        handleSegmentsRemove();
        handleTypeRemove();
        handleKDDegreeRemove();
    }, [
        handleFiltersQueryChange,
        handleTopicRemove,
        handleCoveredRemove,
        handleSegmentsRemove,
        handleTypeRemove,
        handleKDDegreeRemove,
    ]);

    // 切换页数
    const changePageSize = (s) => {
        setPage(1);
        setSize(s);
        setCurrentPageSize(s);
        getKeywordsList(1, s, queryValue);
    }

    // 失去焦点
    const handlePageBlur = (e) => {
        setPage(Number(e));
        getKeywordsList(Number(e), size, queryValue);
    }

    // 分页
    const changePageTable = (p) => {
        setPage(p);
        getKeywordsList(p, size, queryValue);
    }

    // 关闭弹窗seg
    const handleCancelDelSeg = () => {
        setDelSegState(false);
    }

    // 跳转ai博客生成页
    const jumpPageUrl = (url, query) => {
        let path = {
            pathname: url,
            query: query
        }
        props.history.push(path);
    }

    // 继续任务
    const handleContinueTask = (id, query = {}) => {
        setWriteLoading(id);
        getBlogProgress().then(res => {
            // 判断状态 跳转
            let url = '/content-seo/ai-blog-generator/generate';
            let _query = {
                type: "selectKeyword",
                language: query.language,
                location: query.location,
                keyword: query.keyword,
            };
            if (res.ack === 1) {
                let _t = res.data?.record || {};
                let _business = res.data?.business_data || {};
                if (_t?.status === 0) {
                    _query = {
                        type: "selectKeyword",
                        record_id: _t.id,
                        language: _t.language || _business.content_language,
                        location: _t.location || _business.audience_location,
                        keyword: _t.keyword,
                    }
                } else {
                    _query.language = _business.content_language;
                    _query.location = _business.audience_location;
                }
            }
            setGeneratingTipState(false);
            setWriteLoading(-1);
            jumpPageUrl(url, _query);
        })
    }

    // 直接开始新的任务
    const handleGeneratingNew = () => {
        let url = '/content-seo/ai-blog-generator/generate';
        let _id = jumpBlogIdRef.current;
        const objs = tableData.find(item => item.id === _id);
        let _query = {
            type: "selectKeyword",
            keyword: objs?.keyword || "",
            language: businessData.content_language,
            location: businessData.audience_location,
        }
        setGeneratingTipState(false);
        jumpPageUrl(url, _query);
    }

    // 跳转创建博客
    const jumpCreateBlog = (id, val, isVerify = false) => {
        jumpBlogIdRef.current = id;
        // 缓存值
        if (val) {
            keywordSelRef.current = val;
        }
        // setWritePopState(-1);
        // 判断积分是否足够
        if (AiPoints >= 20 || isVerify) {
            if (recordData?.status === 0) {
                setGeneratingTipState(true);
            } else {
                let _query = {
                    type: "selectKeyword",
                    keyword: keywordSelRef.current,
                    language: businessData.content_language,
                    location: businessData.audience_location,
                }
                handleContinueTask(id, _query);
            }
        } else {
            if (userLevel !== 1 && [30002, 30003, 40002].includes(ai_usage_status)) {
                if ([40002].includes(ai_usage_status)) {
                    openUpdateLimit();
                } else {
                    props.openOverageModal({ type: 'points', points: 20, onSuccess: (res) => { toggleToast(t(res.msg)); getKeywordData(null, true); } });
                }
            } else if (ai_usage_status === true) {
                setWriteLoading(id);
                handleOverchargeState(true, 20);
            } else if (userLevel === 3) {
                handleBuyAiCreditsState(true);
            } else {
                upgradeShow(2, true);
            }
        }
    }

    // 超额扣费（AI 积分直充：ai_usage_status === true 场景）
    const handleOverchargeState = async (state, defalutPoints = 0) => {
        setAgreeLoading(true);
        let params = {
            points: defalutPoints > 0 ? defalutPoints : 20
        }
        const res = await reqHandleAIUsagePayment(params);
        if (res.ack === 1) {
            toggleToast(t(res.msg));
            getKeywordData(null, true);
        } else {
            toggleToast(t(res.msg), true);
        }

        if (res) {
            setAgreeLoading(false);
        }
    }

    // 购买积分提示
    const handleBuyAiCreditsState = (_state) => {
        setBuyAiCreditsState(_state)
    }

    // 跳转购买积分
    const jumpPricingCreditsBuy = () => {
        let paths = {
            pathname: '/plan',
            query: "pay_credits",
        }
        props.history.push(paths)
    }

    // 跳转设置页
    const jumpSettingPage = () => {
        let paths = {
            pathname: '/settings',
            query: "overage",
        }
        props.history.push(paths)
    }

    // 导出记录
    const exportKeywordsData = async () => {
        if (userLevel !== 3) {
            upgradeShow(2)
        } else {
            setExportPopState(false);
            setExportLoading(true);
            const currentCoveredSel = coveredSelRef.current;
            const currentSegmentsSel = segmentsSelRef.current;
            const currentTypeSel = typeSelRef.current;
            let params = {
                query: queryValue,
            }
            if (currentCoveredSel && !isEmpty(currentCoveredSel)) {
                params.covg = currentCoveredSel[0] === 'Yes' ? 1 : 0
            }
            if (currentSegmentsSel && !isEmpty(currentSegmentsSel)) {
                params.category_ids = currentSegmentsSel;
            }
            if (currentTypeSel && !isEmpty(currentTypeSel)) {
                params.from = currentTypeSel;
            }
            const res = await reqExportKeywords(params);
            if (res.ack === 1) {
                setTimeout(() => {
                    openExportHistory(true);
                    setExportLoading(false);
                }, 500)
            } else {
                toggleToast(t(res.msg), true);
                setExportLoading(false);
            }
        }
    }

    // 打开导出记录
    const openExportHistory = (isReq = false) => {
        setExportPopState(!exportPopState);
        setExportRecordsState(true);
        setRecordLoading(true);
        if (!getRecordState || isReq) {
            getExportRecordData();
        } else {
            setRecordLoading(false);
        }
    }

    // 获取记录
    const getExportRecordData = async () => {
        const res = await reqGetExportRecord();
        if (res.ack === 1) {
            setGetRecordState(true);
            setExportRecordsData(res.data);
            setRecordLoading(false);
            setRefreshLoading(false);
        } else {
            toggleToast(t(res.msg), true);
        }
    }

    // 选择话题
    // const handleSelectTopic = (data) => {
    //     setTopicSel(data);
    // }

    // 刷新
    const refreshExportRecord = () => {
        setRefreshLoading(true);
        getExportRecordData();
    }

    // 设置提示banner
    const setTipBanner = (msg, tone = 'critical') => {
        setPageTipBanner({ msg, tone });
    }

    //点击联系客服
    const handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            props.toggleToast(t("Try again later"), true);
        }
    }

    // 关闭密码
    const closeDomainBannerObj = () => {
        setActiveBoxAudit(false);
        try {
            sessionStorage.setItem('activeBoxKeyWebsite', 'close')
        } catch (e) { }
    }

    // 关闭banner
    const closeTipBanner = () => {
        // isShowTipBanner: false,
        try {
            sessionStorage.setItem('isShowTipBannerMywebsite', 'close');
        } catch (e) {
            console.warn(e)
        }
    }

    // 解锁排名
    const handleUnlockPosition = async (e, idArr) => {
        e && e.stopPropagation();
        setUnlockId(idArr);
        let params = {
            keyword_ids: idArr,
        }
        const res = await reqUnlockKeywordsPosition(params);
        if (res.ack === 1) {
            getKeywordsList(page, size, queryValue);
        } else {
            setTipBanner(res.msg);
        }
        setUnlockId([]);
        // setGlassId(-1);
    }

    // 删除segmenet
    const handleDelSegments = () => {
        let newList = cloneDeep(segmentsList);
        let _index = -1;
        segmentsList.find((d, i) => {
            if (d.value === delSegData.value) {
                _index = i;
            }
        });
        newList.splice(_index, 1)
        submitUpdSegments(newList, 'del');
    }

    // 提交数据
    const submitUpdSegments = async (data, type = 'save') => {
        setCreateLoading(true);
        setDelSegLoading(true);
        let params = {
            category: data.map(d => {
                return {
                    id: d.value,
                    name: d.label
                }
            })
        };
        const res = await reqSaveCategory(params);
        if (res.ack === 1) {
            toggleToast(type === 'save' ? t("Saved") : t("Deleted"));
            setDelSegState(false);
            setSegmentsList(data);
            let _statusArr = [];
            data.forEach(d => {
                if (d.states) {
                    _statusArr.push(d.value);
                }
            })
            setDelSegData({});
            setSegmentsSelArr(_statusArr)
            setSegmentVal("");
            setCreateSegmentState(true);
            setEditSegId(-1);
        } else {
            toggleToast(t(res.msg), true);
        }
        setCreateLoading(false);
        setDelSegLoading(false);
    }

    // 关闭创建弹窗
    const handleCloseCreateModal = () => {
        setOpenState(false);
    }

    // 重置参数
    const handleResetAll = () => {
        clearSelection();
        getKeywordsList(page, size, queryValue);
    }

    // 更新segments列表
    const handleCallbackData = (data) => {
        getKeywordData(data);
    }

    // 排序
    const onSortColumnData = (e, v) => {
        if (e === 1) {
            setKdSort(v === 'descending' ? 'ascending' : 'descending');
        } else if (e === 2) {
            setVolumeSort(v === 'descending' ? 'ascending' : 'descending');
        } else if (e === 3) {
            setTrafficSort(v === 'descending' ? 'ascending' : 'descending');
        } else { }
        sortInxRef.current = e === 1 ? 'kd' : e === 2 ? 'volume' : 'traffic';
        sortTypeRef.current = v === 'descending' ? 'asc' : 'desc';
        getKeywordsList(page, size, queryValue)
    }

    // 关闭弹窗
    const handleCloseManageModal = () => {
        setIsShowCategoryModal(false);
    }

    // 切换创建
    const handleCreateSegment = () => {
        setCreateSegmentState(!createSegmentState);
    }

    // 输入
    const handleSegmentValChange = (v) => {
        setSegmentVal(v)
    }

    // 失焦
    const blurSegmentChange = () => {
        if (!segmentVal) {
            setCreateSegmentState(true);
        }
    }

    // 创建segmenet
    const handleCreateSegments = () => {
        let newList = cloneDeep(segmentsList);
        newList.push({
            id: 0,
            value: 0,
            label: segmentVal,
            keyword_count: 0,
        })
        submitUpdSegments(newList);
    }

    // 编辑关键词
    const handleEditSegment = (obj) => {
        setCategoryVal(obj.label);
        setEditSegId(obj.id);
    }

    // 失焦保存
    const handleBlurEditSeg = (id) => {
        let newList = cloneDeep(segmentsList);
        let isChange = false;
        newList.forEach(item => {
            if (item.id === id && item.label !== categoryVal && categoryVal) {
                item.label = categoryVal;
                isChange = true;
            }
        })
        if (isChange) {
            submitUpdSegments(newList);
        } else {
            setEditSegId(-1);
        }
    }

    // 输入
    const handleChangeCategory = (v) => {
        setCategoryVal(v);
    }

    // 跳转策略
    const handleJumpPlanner = (keyword) => {
        let paths = {
            pathname: '/content-seo/keyword-content-planner',
            query: keyword,
        }
        props.history.push(paths)
    }

    // 在组件卸载时清除定时器，防止内存泄漏
    useEffect(() => {
        return () => {
            debouncedGetKeywordsList.cancel();
        };
    }, [debouncedGetKeywordsList]);

    // 监听表格行触摸
    // useEffect(() => {
    //     const parent = listRef.current;
    //     if (!parent) return;
    //     const handleMouseEnter = (e) => {
    //         const target = e.target;
    //         const row = target.closest(".Polaris-IndexTable__TableRow");
    //         if (row && tableData.length > 0) {
    //             const index = Array.prototype.indexOf.call(row.parentNode?.children, row);
    //             if (index >= 0 && tableData[index]) {
    //                 setGlassId(tableData[index].id);
    //             }
    //         }
    //     };

    //     const handleMouseLeave = () => {
    //         setGlassId(-1);
    //     };

    //     parent.addEventListener("mouseover", handleMouseEnter);
    //     parent.addEventListener("mouseout", handleMouseLeave);

    //     return () => {
    //         parent.removeEventListener("mouseover", handleMouseEnter);
    //         parent.removeEventListener("mouseout", handleMouseLeave);
    //     };
    // }, [tableData, listRef])

    // 是否隐藏弹层
    useEffect(() => {
        let objs = document.querySelectorAll('.Polaris-Popover__PopoverOverlay--open');
        if (objs && objs.length > 0) {
            objs.forEach(item => {
                // item.style.opacity = (delSegState || exportRecordsState || isShowCategoryModal) ? 0 : 1;
                item.style.zIndex = (delSegState || exportRecordsState || isShowCategoryModal) ? -1 : 2147483003;
            })
        }
    }, [delSegState, exportRecordsState, isShowCategoryModal])

    // 针对列表数据变化情况筛选
    useEffect(() => {
        pageRef.current = page;
        sizeRef.current = size;
        clearSelection();
    }, [page, size, queryValue])

    // 筛选条件更新列表
    useEffect(() => {
        clearSelection();
        KdDegreeRef.current = kdSelArr;
        coveredSelRef.current = coveredSelArr;
        segmentsSelRef.current = segmentsSelArr;
        typeSelRef.current = typeSelArr;
        if (notFirstReq) {
            setPage(1);
            pageRef.current = 1;
            getKeywordsList(1, size, queryValue);
        }
    }, [kdSelArr, coveredSelArr, segmentsSelArr, typeSelArr])
    // topicSelArr,

    // 设置等级
    useEffect(() => {
        setUserLevel(level);
    }, [level])

    // 监听触摸行
    useEffect(() => {
        const parent = listRef.current;
        if (!parent) return;
        let lastHoverId = null;

        const handleMouseOver = (e) => {
            const row = e.target.closest(".Polaris-IndexTable__TableRow");
            if (!row || !parent.contains(row)) return;

            const index = row.rowIndex - 1;
            if (tableData[index] && tableData[index].id !== lastHoverId) {
                lastHoverId = tableData[index].id;
                setHoverReid(Number(lastHoverId));
            }
        };

        const handleMouseOut = (e) => {
            const row = e.target.closest(".Polaris-IndexTable__TableRow");
            if (!row || !parent.contains(row)) return;
            lastHoverId = null;
            setHoverReid(-1);
        };

        parent.addEventListener("mouseover", handleMouseOver);
        parent.addEventListener("mouseout", handleMouseOut);

        return () => {
            parent.removeEventListener("mouseover", handleMouseOver);
            parent.removeEventListener("mouseout", handleMouseOut);
        };
    }, [tableData]);

    // 根据tab切换筛选
    useEffect(() => {
        switch (selected) {
            case 0:
                handleFiltersClearAll();
                break;
            case 1:
            case 2:
                let newArr = cloneDeep(coveredSelArr);
                let type = selected === 1 ? 'Yes' : 'No';
                if (!newArr.includes(type)) {
                    newArr = [type]
                }
                setCoveredSelArr(newArr);
                disambiguateLabel("Covered", newArr, CoveredList);
                break;
            default:
                break;
        }
    }, [selected])

    useEffect(() => {
        let selectArr = tableData.filter(item => selectedResources.includes(item.id) && Boolean(Number(item.website_count) > 0));
        let idArr = selectArr.map(item => item.id);
        if (idArr.length > 0) {
            setUpdDisabled(false);
        } else {
            setUpdDisabled(true);
        }
    }, [tableData, selectedResources])

    useEffect(() => {
        // 浏览器缓存
        try {
            let states = sessionStorage.getItem('isShowTipBannerMywebsite');
            setIsShowTipBanner(!Boolean(states));
        } catch (e) { }
        // 获取数据
        getKeywordData();
        // 获取列表
        getKeywordsList(page, size, queryValue);
        // 监听记录数据
        getBlogProgress();

    }, [])

    // 错误警告banner
    const PageTipBanner = Boolean(pageTipBanner.msg) && <Banner
        tone={pageTipBanner.tone}
        title={pageTipBanner.msg}
        onDismiss={() => {
            setPageTipBanner({ msg: '', tone: '' });
        }}
        action={{
            content: t("Contact us"),
            onAction: handleContactService
        }}
    ></Banner>

    // 域名解析
    const domainBanner = (activeBoxAudit && domainNotResolve && userLevel > 1) && <Card>
        <div className="set_domain_box">
            <Button icon={XIcon} variant="tertiary" onClick={closeDomainBannerObj}></Button>
            <div className="set_domain_box_content">
                <BlockStack gap={200}>
                    <Text variant="headingMd" as="h2">{t("Set Up a Custom Domain")}</Text>
                    <Text variant="bodyMd" as="p" tone="subdued">{t("Use a non-myshopify.com domain to enable full keyword tracking. Once connected, we'll automatically sync all ranking keywords from your website.")}</Text>
                </BlockStack>
                <div>
                    <Button variant="primary" onClick={() => {
                        window.open(resolveUrl)
                    }}>{t("Set Up Custom Domain")}</Button>
                </div>
            </div>
            <div><img src="/imgs/ai/set_domain.png" alt="" /></div>
        </div>
    </Card>

    // 时间提示banner
    const isGetDataLoading = (userLevel > 2 && isShowTipBanner && (!Boolean(queryValue) && topicSelArr.length === 0 && coveredSelArr.length === 0 && segmentsSelArr.length === 0 && typeSelArr.length === 0) && (!isGetData && tableData.length === 0 && !listLoading));
    const TipBanner = isGetDataLoading && <Banner title={
        <div className='flex_layout' style={{ minHeight: '25px' }}>
            <p>{t("We are currently in the process of data extraction. Due to the large volume of data, the processing time may be longer.Please be patient, and we will ensure that the data extraction is completed within 24 hours.")}</p>
            <img src='/imgs/face/PartyingFace.png' alt='Partying Face' />
            <span className='audit_tip_loading'>
                <Spinner size='small' />
            </span>
        </div>
    }
        onDismiss={closeTipBanner}
    >
    </Banner>


    // 正在生成提示弹窗
    const generatingTipModal = <UnfinishedBlogModal
        open={generatingTipState}
        loading={writeLoading !== -1}
        onStartNew={handleGeneratingNew}
        onContinue={() => handleContinueTask(jumpBlogIdRef.current, {})}
        onClose={() => setGeneratingTipState(false)}
        toggleToast={toggleToast}
        recordId={recordId}
    />

    // 分类管理
    const categoryManageModal = <Modal
        title={t("Manage categories")}
        open={isShowCategoryModal && !delSegState}
        secondaryActions={[
            {
                content: t("Close"),
                disabled: !createSegmentState,
                onAction: handleCloseManageModal,
            }
        ]}
        onClose={handleCloseManageModal}
    >
        <Modal.Section>
            <IndexTable
                resourceName={{
                    singular: t("category"),
                    plural: t("categories"),
                }}
                itemCount={segmentsList.length}
                selectedItemsCount={0}
                onSelectionChange={handleSelectionChange}
                headings={[
                    { title: t("Categories") },
                    { title: t("Keywords") },
                    { title: t("Action") },
                ]}
                selectable={false}
            >
                {
                    segmentsList.map(({ id, label, keyword_count }, index) => {
                        return (
                            <IndexTable.Row
                                id={id}
                                key={id}
                                position={index}
                            >
                                <IndexTable.Cell>
                                    {
                                        editSegId === id ? <TextField
                                            value={categoryVal}
                                            focused={true}
                                            onChange={handleChangeCategory}
                                            onBlur={() => handleBlurEditSeg(id)}
                                            disabled={createLoading}
                                            suffix={createLoading ? <span className="edit_segment_suffix"><Spinner size="small" /></span> : null}
                                        /> :
                                            <div className="category_text">
                                                <Text variant="bodyMd" fontWeight="bold" as="p">{label}</Text>
                                            </div>
                                    }
                                </IndexTable.Cell>
                                <IndexTable.Cell>{keyword_count}</IndexTable.Cell>
                                <IndexTable.Cell>
                                    <div className="flex_layout" style={{ gap: '1em' }}>
                                        <Button icon={EditIcon} onClick={() => handleEditSegment({ id, label, keyword_count })}></Button>
                                        <Button icon={DeleteIcon} onClick={() => handleOpenDelSegment({ id, label, keyword_count })}></Button>
                                    </div>
                                </IndexTable.Cell>
                            </IndexTable.Row>
                        );
                    })
                }
            </IndexTable>
            <div className="opera_segment">
                {
                    createSegmentState ? <div className="create_segment flex_layout" onClick={handleCreateSegment}>
                        <span><Icon source={DuplicateIcon} tone="base" /></span>
                        <Button variant="plain">{t("Create new category")}</Button>
                    </div> : <div className="flex_layout">
                        <TextField
                            value={segmentVal}
                            onChange={handleSegmentValChange}
                            onBlur={blurSegmentChange}
                            focused={true}
                        />
                        <Button variant="primary" loading={createLoading} onClick={handleCreateSegments}>{t("Save")}</Button>
                    </div>
                }
            </div>
        </Modal.Section>
    </Modal>

    // 删除提示弹窗
    const delSegmentsModal = <Modal
        open={delSegState}
        title={t("Delete confirm")}
        primaryAction={{
            content: t("Delete"),
            onAction: handleDelSegments,
            loading: delSegLoading
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: handleCancelDelSeg,
                disabled: delSegLoading
            }
        ]}
        onClose={handleCancelDelSeg}
    >
        <Modal.Section>
            <p>{t("This segment will be permanently removed. Your keywords will remain but no longer be categorized under it.")}</p>
        </Modal.Section>
    </Modal>

    // 积分不足提示
    const creditsBuyModal = <Modal
        open={buyAiCreditsState}
        title={t("AI Credit Reminder")}
        primaryAction={{
            content: t("Purchase AI Credits"),
            onAction: () => jumpPricingCreditsBuy()
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => handleBuyAiCreditsState(false)
            }
        ]}
        onClose={() => handleBuyAiCreditsState(false)}
    >
        <Modal.Section>
            <p>{t("Your AI credit balance is insufficient")}</p>
        </Modal.Section>
    </Modal>

    // 导出记录弹窗
    const rowExportData = exportRecordsData.map(
        (
            { id, name, count, export_at, status, is_del }, index
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                position={index}
            >
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="p">{name}</Text>
                </IndexTable.Cell>
                <IndexTable.Cell>{count}</IndexTable.Cell>
                <IndexTable.Cell>{utils.timeFormat(export_at)}</IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        is_del === 1 ? <Badge tone="warning">{t("Expired")}</Badge> : status === 0 ? <Badge tone="info" progress="incomplete">{t("Exporting")}</Badge> : <Badge tone="success" progress="complete">{t("Completed")}</Badge>
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <Button disabled={(status === 0) || (is_del === 1)} icon={SaveIcon} onClick={() => {
                        window.open(`${API_OSS}/export/Keywords/${name}?v=119`)
                    }}>
                    </Button>
                </IndexTable.Cell>
            </IndexTable.Row>
        )
    )
    const exportRecordsModal = <Modal
        open={exportRecordsState}
        title={t("Export records")}
        secondaryActions={[
            {
                content: t("Refresh"),
                onAction: refreshExportRecord,
                loading: refreshLoading,
                icon: RefreshIcon
            },
            {
                content: t("Close"),
                onAction: () => setExportRecordsState(false)
            }
        ]}
        onClose={() => {
            setExportRecordsState(false);
        }}
    >
        <Modal.Section>
            {
                recordLoading ? <div className="loading_box"><Spinner size="small" /></div> :
                    <IndexTable
                        resourceName={resourceName}
                        itemCount={exportRecordsData.length}
                        headings={[
                            { title: t("File name") },
                            { title: t("Records number") },
                            { title: t("Export time") },
                            { title: t("Status") },
                            { title: "" },
                        ]}
                        promotedBulkActions={[]}
                        selectable={false}
                    >
                        {rowExportData}
                    </IndexTable>
            }
        </Modal.Section>
    </Modal>

    // 顶部数据模块
    const upIcon = <svg width="8" height="8" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.583829 6.41608C0.398001 6.23025 0.398001 5.92896 0.583829 5.74313L4.93088 1.39608L2.49053 1.3962C2.22773 1.39622 2.01468 1.18318 2.01466 0.920384C2.01465 0.657582 2.22768 0.444529 2.49048 0.444516L6.0797 0.444336C6.20591 0.44433 6.32695 0.494463 6.4162 0.583707C6.50544 0.672951 6.55558 0.793994 6.55557 0.920204L6.55539 4.50942C6.55538 4.77222 6.34232 4.98526 6.07952 4.98524C5.81672 4.98523 5.60369 4.77218 5.6037 4.50937L5.60382 2.06903L1.25677 6.41608C1.07095 6.6019 0.769658 6.6019 0.583829 6.41608Z" fill="#29CC6A" />
    </svg>
    const downIcon = <svg width="8" height="8" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M1.0838 0.583707C1.26963 0.397879 1.57092 0.397879 1.75675 0.583707L6.1038 4.93076L6.10367 2.49041C6.10366 2.22761 6.31669 2.01455 6.57949 2.01454C6.8423 2.01453 7.05535 2.22756 7.05536 2.49036L7.05554 6.07958C7.05555 6.20579 7.00541 6.32683 6.91617 6.41608C6.82693 6.50532 6.70588 6.55545 6.57967 6.55545L2.99046 6.55527C2.72765 6.55525 2.51462 6.3422 2.51464 6.0794C2.51465 5.8166 2.7277 5.60357 2.9905 5.60358L5.43085 5.6037L1.0838 1.25665C0.897974 1.07082 0.897974 0.769536 1.0838 0.583707Z" fill="#B5B5B5" />
    </svg>
    const TopDataBlock = userLevel > 1 && <div className="keyword_top_block">
        <Card padding={0}>
            <div className="keyword_rank_data">
                <div className="k_rank_item">
                    <Tooltip content={t("The total number of keywords that your target ranks for in the top 100 organic search results.")}>
                        <Text variant="headingMd" as="h2">{t("Keywords")}</Text>
                    </Tooltip>
                    <div className="keyword_data">
                        <p>{userLevel === 1 ? '-' : kwOneHundred}</p>
                        {(kwOneHundredPerc !== 0 && userLevel !== 1) ? <span className={kwOneHundredPerc > 0 ? "up_keyword" : "down_keyword"}>
                            {kwOneHundredPerc > 0 ? upIcon : downIcon}
                            {
                                kwOneHundredPerc === 99 ? <span>+{kwOneHundred}</span> : <span>{`${kwOneHundredPerc}%`}</span>
                            }
                        </span> : null}
                    </div>
                </div>
                <div className="k_rank_item">
                    <Tooltip content={t("The estimated number of monthly visits that your target gets from organic search.")}>
                        <Text variant="headingMd" as="h2">{t("Traffic")}</Text>
                    </Tooltip>
                    <div className="keyword_data">
                        <p>{userLevel === 1 ? '-' : traffic}</p>
                        {(trafficPerc !== 0 && userLevel !== 1) ? <span className={trafficPerc > 0 ? "up_keyword" : "down_keyword"}>
                            {trafficPerc > 0 ? upIcon : downIcon}
                            {
                                trafficPerc === 99 ? <span>+{traffic}</span> : <span>{`${trafficPerc}%`}</span>
                            }
                        </span> : null}
                    </div>
                </div>
                <div className="k_rank_item">
                    <Tooltip content={t("The number of keywords for which your content ranks in the top 10 positions on search engines.")}>
                        <Text variant="headingMd" as="h2">{t("KW IN TOP 10")}</Text>
                    </Tooltip>
                    <div className="keyword_data">
                        <p>{userLevel === 1 ? '-' : kwTen}</p>
                        {(kwTenPerc !== 0 && userLevel !== 1) ? <span className={kwTenPerc > 0 ? "up_keyword" : "down_keyword"}>
                            {kwTenPerc > 0 ? upIcon : downIcon}
                            {
                                kwTenPerc === 99 ? <span>+{kwTen}</span> : <span>{`${kwTenPerc}%`}</span>
                            }
                        </span> : null}
                    </div>
                </div>
            </div>
        </Card>
        {/* <Card padding={300}>
            <Tooltip content={t("The number of keywords for which your content ranks in the top 50 positions on search engines.")}>
                <Text variant="headingMd" as="h2">{t("KW IN TOP 50")}</Text>
            </Tooltip>
            <div className="keyword_data">
                <p>{userLevel === 1 ? '-' : kwFifty}</p>
                {(kwFiftyPerc !== 0 && userLevel !== 1) ? <span className={kwFiftyPerc > 0 ? "up_keyword" : "down_keyword"}>
                    {kwFiftyPerc > 0 ? upIcon : downIcon}
                    {
                        kwFiftyPerc === 99 ? <span>+{kwFifty}</span> : <span>{`${kwFiftyPerc}%`}</span>
                    }
                </span> : null}
            </div>
        </Card> */}
        {/* <Card padding={300}>
            <Text variant="headingMd" as="h3">{t("Next update time")}</Text>
            <div className="keyword_data">
                {userLevel === 1 ? '-' : (updTime || '-')}
            </div>
        </Card> */}
    </div>

    // 测试数据
    const testRowData = testData.map(
        (
            { id, keyword },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={false}
                position={index}
            >
                <IndexTable.Cell>
                    <Text variant="bodyMd" fontWeight="bold" as="p">{keyword}</Text>
                </IndexTable.Cell>
                <IndexTable.Cell>-</IndexTable.Cell>
                <IndexTable.Cell>-</IndexTable.Cell>
                <IndexTable.Cell>-</IndexTable.Cell>
                <IndexTable.Cell>-</IndexTable.Cell>
                <IndexTable.Cell>-</IndexTable.Cell>
                <IndexTable.Cell>
                    <Button icon={ViewIcon} disabled>{t("View")}</Button>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    // 关键词列表内容
    const rowKeywordData = tableData.map(
        (
            { id, keyword, kd, volume, traffic, position, website_count, websites },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
            >
                <IndexTable.Cell>
                    <div className="keyword_text">
                        <Text variant="bodyMd" fontWeight="bold" as="p">{userLevel === 1 ? '****' : keyword}</Text>
                        {
                            Boolean(Number(website_count) > 0) ? <div><Badge tone="success">{t("Covered")}</Badge></div> : null
                        }
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <Badge tone={kd <= 29 ? 'success' : kd <= 49 ? 'attention' : kd <= 69 ? 'warning' : 'critical'}>{`${kd}`}</Badge>
                </IndexTable.Cell>
                <IndexTable.Cell>{formatNumber(volume)}</IndexTable.Cell>
                <IndexTable.Cell>{formatNumber(traffic)}</IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(Number(website_count) > 0) ?
                            <div className="keyword_position_info">
                                {/* {
                                    (Number(unlocking_count) === 0 && Number(unlocked_count) === 0) && <div className="glass_data">
                                        {
                                            (Boolean(glassId === id) || Boolean(unlockId === id)) && <Button icon={LockMinor} onClick={(e) => handleUnlockPosition(e, id)} loading={Boolean(unlockId === id)} disabled={unlockId !== -1}></Button>
                                        }
                                    </div>
                                } */}
                                {
                                    <div className="keyword_position flex_layout">
                                        <span>{position}</span>
                                        <div style={{ opacity: hoverReid === id || unlockId.includes(id) ? 1 : 0 }}>
                                            <Button loading={Boolean(unlockId.includes(id))} icon={RefreshIcon} variant="tertiary" onClick={(e) => handleUnlockPosition(e, [id])}></Button>
                                        </div>
                                        {/* {
                                            Boolean(unlockId === id) ? <span><Spinner size="small" /></span> : <span className="kp_action" onClick={(e) => handleUnlockPosition(e, id)} style={{ opacity: hoverReid === id ? 1 : 0 }}><Icon source={RefreshMinor} tone="base" /></span>
                                        } */}
                                    </div>
                                }
                            </div> : null
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(websites.length > 0) ? <div className="table_url_item ellipsis_2" onClick={(e) => {
                            e && e.stopPropagation();
                        }}>
                            <Tooltip
                                width={"wide"}
                                content={websites.map(item => <a key={item} href={item} style={{ display: 'block', color: '#005bd3' }} target="_blank" rel="noopener noreferrer">{item}</a>)}
                            >
                                {/* 判断是否https开头 */}
                                <a href={websites[0].startsWith('https') ? websites[0] : `https://${websites[0]}`} target="_blank" rel="noopener noreferrer">{websites[0]}</a>
                            </Tooltip>
                        </div> : '-'
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div className="flex_layout table_icon_group">
                        <Tooltip content={t("Generate keyword strategy")}>
                            <Button icon={WandIcon} onClick={(e) => {
                                e && e.stopPropagation();
                                handleJumpPlanner(keyword)
                            }}></Button>
                        </Tooltip>
                        {
                            Boolean(websites.length > 0) ? <Tooltip content={t("Preview the blog")}>
                                <Button icon={ViewIcon} disabled={userLevel === 1} onClick={(e) => {
                                    e && e.stopPropagation();
                                    window.open(websites[0].startsWith('https') ? websites[0] : `https://${websites[0]}`, '_blank');
                                    // handleViewUrl(e, id, keyword, Number(website_count))
                                }} loading={websiteLoading === id}></Button>
                            </Tooltip> : <Tooltip content={t("Generate a Blog Post")}>
                                <Button variant="primary" icon={BlogIcon} loading={writeLoading === id} disabled={writeLoading !== -1 || userLevel === 1} onClick={(e) => {
                                    e && e.stopPropagation();
                                    jumpCreateBlog(id, keyword, false);
                                }}></Button>
                            </Tooltip>
                        }
                    </div>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    // 分页
    const footerContentMsg = <FooterPageSelect
        page={page}
        current_PageSize={current_PageSize}
        total={total}
        changePageSize={changePageSize}
        handlePageBlur={handlePageBlur}
        tableLoading={listLoading}
    />

    // 列表
    const TopicTableList = <div className="topic_list" ref={listRef}>
        <Card padding={0}>
            <IndexFilters
                sortOptions={false}
                sortSelected={sortSelected}
                queryValue={queryValue}
                queryPlaceholder={t("Search keywords")}
                disabled={userLevel === 1}
                onQueryChange={handleFiltersQueryChange}
                onQueryClear={() => handleFiltersQueryChange("")}
                onSort={setSortSelected}
                primaryAction={false}
                cancelAction={{
                    onAction: onHandleCancel,
                    disabled: false,
                    loading: false,
                }}
                tabs={[
                    {
                        id: 'All',
                        content: t("All"),
                        value: 'All',
                    },
                    {
                        id: 'Covered',
                        content: t("Covered"),
                        value: 'Covered',
                    },
                    {
                        id: 'Uncovered',
                        content: t("Uncovered"),
                        value: 'Uncovered',
                    },
                ]}
                selected={selected}
                onSelect={setSelected}
                canCreateNewView={false}
                onCreateNewView={onCreateNewView}
                filters={filters}
                appliedFilters={appliedFilters}
                onClearAll={handleFiltersClearAll}
                mode={mode}
                setMode={setMode}
                loading={listLoading}
            />
            {
                userLevel === 1 ? <div className="upgrade_panel">
                    <div className="upgrade_panel_content">
                        <Text variant="headingLg" as="h2">{t("Keyword Rank Tracker")}</Text>
                        <div className="u-intro">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14.4519 3.50005L14.5 3.5001L14.5481 3.50005C14.73 3.49978 14.9193 3.49949 15.0914 3.53372C15.7856 3.67181 16.3283 4.21448 16.4663 4.90869C16.5006 5.08077 16.5003 5.27008 16.5 5.452V14.5482C16.5003 14.7301 16.5006 14.9194 16.4663 15.0915C16.3283 15.7857 15.7856 16.3284 15.0914 16.4665C14.9193 16.5007 14.73 16.5004 14.5481 16.5001L14.5 16.5001L14.4519 16.5001C14.27 16.5004 14.0807 16.5007 13.9086 16.4665C13.2144 16.3284 12.6717 15.7857 12.5336 15.0915C12.4994 14.9194 12.4997 14.7301 12.4999 14.5482V5.45199C12.4997 5.27008 12.4994 5.08077 12.5336 4.90869C12.6717 4.21448 13.2144 3.67181 13.9086 3.53372C14.0807 3.49949 14.27 3.49978 14.4519 3.50005ZM14.1993 5.00529C14.1017 5.02551 14.0254 5.10179 14.0052 5.19938C14.0047 5.20301 14.0031 5.21792 14.0019 5.25231C14.0001 5.30666 14 5.37885 14 5.5001V14.5001C14 14.6213 14.0001 14.6935 14.0019 14.7479C14.0031 14.7823 14.0047 14.7972 14.0052 14.8008C14.0254 14.8984 14.1017 14.9747 14.1993 14.9949C14.2029 14.9953 14.2178 14.997 14.2522 14.9981C14.3065 15 14.3787 15.0001 14.5 15.0001C14.6212 15.0001 14.6934 15 14.7478 14.9981C14.7822 14.997 14.7971 14.9953 14.8007 14.9949C14.8983 14.9747 14.9746 14.8984 14.9948 14.8008C14.9952 14.7972 14.9968 14.7823 14.998 14.7479C14.9999 14.6935 15 14.6213 15 14.5001V5.5001C15 5.37885 14.9999 5.30666 14.998 5.25231C14.9968 5.21792 14.9952 5.20301 14.9948 5.19938C14.9746 5.10179 14.8983 5.02551 14.8007 5.00529C14.7971 5.00485 14.7822 5.00324 14.7478 5.00206C14.6934 5.0002 14.6212 5.0001 14.5 5.0001C14.3787 5.0001 14.3065 5.0002 14.2522 5.00206C14.2178 5.00324 14.2029 5.00485 14.1993 5.00529Z" fill="#8A8A8A" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M5.45187 9.00005L5.49997 9.0001L5.54808 9.00005C5.72999 8.99978 5.9193 8.99949 6.09138 9.03372C6.78559 9.17181 7.32826 9.71448 7.46635 10.4087C7.50058 10.5808 7.5003 10.7701 7.50002 10.952L7.49997 11.0001V14.5001L7.50002 14.5482C7.5003 14.7301 7.50058 14.9194 7.46635 15.0915C7.32826 15.7857 6.78559 16.3284 6.09138 16.4665C5.9193 16.5007 5.72999 16.5004 5.54808 16.5001L5.49997 16.5001L5.45187 16.5001C5.26996 16.5004 5.08065 16.5007 4.90857 16.4665C4.21436 16.3284 3.67169 15.7857 3.5336 15.0915C3.49937 14.9194 3.49965 14.7301 3.49993 14.5482V10.952C3.49965 10.7701 3.49937 10.5808 3.5336 10.4087C3.67169 9.71448 4.21436 9.17181 4.90857 9.03372C5.08065 8.99949 5.26996 8.99978 5.45187 9.00005ZM5.19926 10.5053C5.10167 10.5255 5.02538 10.6018 5.00517 10.6994C5.00473 10.703 5.00311 10.7179 5.00194 10.7523C5.00008 10.8067 4.99997 10.8788 4.99997 11.0001V14.5001C4.99997 14.6213 5.00008 14.6935 5.00194 14.7479C5.00312 14.7823 5.00473 14.7972 5.00517 14.8008C5.02538 14.8984 5.10166 14.9747 5.19926 14.9949C5.20288 14.9953 5.21779 14.997 5.25219 14.9981C5.30654 15 5.37872 15.0001 5.49997 15.0001C5.62122 15.0001 5.69341 15 5.74776 14.9981C5.78216 14.997 5.79707 14.9953 5.80069 14.9949C5.89828 14.9747 5.97456 14.8984 5.99478 14.8008C5.99522 14.7972 5.99683 14.7823 5.99801 14.7479C5.99987 14.6935 5.99997 14.6213 5.99997 14.5001V11.0001C5.99997 10.8788 5.99987 10.8067 5.99801 10.7523C5.99683 10.7179 5.99522 10.703 5.99478 10.6994C5.97457 10.6018 5.89828 10.5255 5.80069 10.5053C5.79707 10.5048 5.78216 10.5032 5.74776 10.5021C5.69341 10.5002 5.62122 10.5001 5.49997 10.5001C5.37872 10.5001 5.30654 10.5002 5.25219 10.5021C5.21779 10.5032 5.20288 10.5048 5.19926 10.5053Z" fill="#8A8A8A" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.99997 6.0001L9.95187 6.00005C9.76996 5.99978 9.58065 5.99949 9.40857 6.03372C8.71436 6.17181 8.17169 6.71448 8.0336 7.40869C7.99937 7.58077 7.99965 7.77008 7.99993 7.95199L7.99997 8.0001V14.5001L7.99993 14.5482C7.99965 14.7301 7.99937 14.9194 8.0336 15.0915C8.17169 15.7857 8.71436 16.3284 9.40857 16.4665C9.58065 16.5007 9.76996 16.5004 9.95187 16.5001L9.99997 16.5001L10.0481 16.5001C10.23 16.5004 10.4193 16.5007 10.5914 16.4665C11.2856 16.3284 11.8283 15.7857 11.9663 15.0915C12.0006 14.9194 12.0003 14.7301 12 14.5482V7.952C12.0003 7.77008 12.0006 7.58077 11.9663 7.40869C11.8283 6.71448 11.2856 6.17181 10.5914 6.03372C10.4193 5.99949 10.23 5.99978 10.0481 6.00005L9.99997 6.0001ZM9.50517 7.69938C9.52538 7.60179 9.60167 7.52551 9.69926 7.50529C9.70288 7.50485 9.71779 7.50324 9.75219 7.50206C9.80654 7.5002 9.87872 7.5001 9.99997 7.5001C10.1212 7.5001 10.1934 7.5002 10.2478 7.50206C10.2822 7.50324 10.2971 7.50485 10.3007 7.50529C10.3983 7.52551 10.4746 7.60179 10.4948 7.69939C10.4952 7.70301 10.4968 7.71792 10.498 7.75231C10.4999 7.80666 10.5 7.87885 10.5 8.0001V14.5001C10.5 14.6213 10.4999 14.6935 10.498 14.7479C10.4968 14.7823 10.4952 14.7972 10.4948 14.8008C10.4746 14.8984 10.3983 14.9747 10.3007 14.9949C10.2971 14.9953 10.2822 14.997 10.2478 14.9981C10.1934 15 10.1212 15.0001 9.99997 15.0001C9.87872 15.0001 9.80654 15 9.75219 14.9981C9.7178 14.997 9.70288 14.9953 9.69926 14.9949C9.60167 14.9747 9.52538 14.8984 9.50517 14.8008C9.50473 14.7972 9.50312 14.7823 9.50194 14.7479C9.50008 14.6935 9.49997 14.6213 9.49997 14.5001V8.0001C9.49997 7.87885 9.50008 7.80666 9.50194 7.75231C9.50311 7.71792 9.50473 7.70301 9.50517 7.69938L9.50478 7.70132C9.50511 7.69965 9.50515 7.69952 9.50517 7.69938Z" fill="#8A8A8A" />
                            </svg>
                            <Text variant="bodyMd" as="p" tone="subdued">{t("Track daily ranking changes for your existing keywords.")}</Text>
                        </div>
                        <div className="u-intro">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.0179 3.5H10.9821C11.7949 3.49999 12.4506 3.49999 12.9815 3.54336C13.5281 3.58803 14.0082 3.68239 14.4525 3.90873C15.1581 4.26825 15.7317 4.84193 16.0913 5.54754C16.3176 5.99175 16.412 6.4719 16.4566 7.01853C16.5 7.54944 16.5 8.20505 16.5 9.01788V9.25C16.5 9.66421 16.1642 10 15.75 10C15.3358 10 15 9.66421 15 9.25V9.05C15 8.19755 14.9994 7.60331 14.9616 7.14068C14.9245 6.6868 14.8554 6.42604 14.7548 6.22852C14.539 5.80516 14.1948 5.46095 13.7715 5.24524C13.574 5.1446 13.3132 5.07546 12.8593 5.03838C12.3967 5.00058 11.8025 5 10.95 5H9.05C8.19755 5 7.60331 5.00058 7.14068 5.03838C6.6868 5.07546 6.42604 5.1446 6.22852 5.24524C5.80516 5.46095 5.46095 5.80516 5.24524 6.22852C5.1446 6.42604 5.07547 6.6868 5.03838 7.14068C5.00058 7.60331 5 8.19755 5 9.05V10.95C5 11.8025 5.00058 12.3967 5.03838 12.8593C5.07547 13.3132 5.1446 13.574 5.24524 13.7715C5.46095 14.1948 5.80516 14.539 6.22852 14.7548C6.42604 14.8554 6.6868 14.9245 7.14068 14.9616C7.60331 14.9994 8.19755 15 9.05 15H9.25C9.66421 15 10 15.3358 10 15.75C10 16.1642 9.66421 16.5 9.25 16.5H9.01788C8.20505 16.5 7.54944 16.5 7.01853 16.4566C6.4719 16.412 5.99175 16.3176 5.54754 16.0913C4.84193 15.7317 4.26825 15.1581 3.90873 14.4525C3.68239 14.0082 3.58803 13.5281 3.54336 12.9815C3.49999 12.4506 3.49999 11.7949 3.5 10.9821V9.0179C3.49999 8.20506 3.49999 7.54944 3.54336 7.01853C3.58803 6.4719 3.68239 5.99175 3.90873 5.54754C4.26825 4.84193 4.84193 4.26825 5.54754 3.90873C5.99175 3.68239 6.4719 3.58803 7.01853 3.54336C7.54944 3.49999 8.20506 3.49999 9.0179 3.5Z" fill="#8A8A8A" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M10.25 13C10.25 11.4812 11.4812 10.25 13 10.25C14.5188 10.25 15.75 11.4812 15.75 13C15.75 13.4869 15.6235 13.9442 15.4015 14.3409L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L14.3409 15.4015C13.9442 15.6235 13.4869 15.75 13 15.75C11.4812 15.75 10.25 14.5188 10.25 13ZM13 11.75C12.3096 11.75 11.75 12.3096 11.75 13C11.75 13.6904 12.3096 14.25 13 14.25C13.6904 14.25 14.25 13.6904 14.25 13C14.25 12.3096 13.6904 11.75 13 11.75Z" fill="#8A8A8A" />
                                <path d="M7 7.75C7 7.33579 7.33579 7 7.75 7H12.25C12.6642 7 13 7.33579 13 7.75C13 8.16421 12.6642 8.5 12.25 8.5H7.75C7.33579 8.5 7 8.16421 7 7.75Z" fill="#8A8A8A" />
                                <path d="M7.75 10C7.33579 10 7 10.3358 7 10.75C7 11.1642 7.33579 11.5 7.75 11.5H9.25C9.66421 11.5 10 11.1642 10 10.75C10 10.3358 9.66421 10 9.25 10H7.75Z" fill="#8A8A8A" />
                            </svg>
                            <Text variant="bodyMd" as="p" tone="subdued">{t("Identify high-value keywords with real growth potential.")}</Text>
                        </div>
                        <div className="u-intro">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 6.25C3.5 4.73122 4.73122 3.5 6.25 3.5H13.75C15.2688 3.5 16.5 4.73122 16.5 6.25V10.77C16.5 11.1842 16.1642 11.52 15.75 11.52C15.3358 11.52 15 11.1842 15 10.77V6.25C15 5.55964 14.4404 5 13.75 5H6.25C5.55964 5 5 5.55964 5 6.25V13.75C5 14.4404 5.55964 15 6.25 15H11.17C11.5842 15 11.92 15.3358 11.92 15.75C11.92 16.1642 11.5842 16.5 11.17 16.5H6.25C4.73122 16.5 3.5 15.2688 3.5 13.75V6.25Z" fill="#8A8A8A" />
                                <path d="M15.75 12.5C16.1642 12.5 16.5 12.8358 16.5 13.25V14.5H17.75C18.1642 14.5 18.5 14.8358 18.5 15.25C18.5 15.6642 18.1642 16 17.75 16H16.5V17.25C16.5 17.6642 16.1642 18 15.75 18C15.3358 18 15 17.6642 15 17.25V16H13.75C13.3358 16 13 15.6642 13 15.25C13 14.8358 13.3358 14.5 13.75 14.5H15V13.25C15 12.8358 15.3358 12.5 15.75 12.5Z" fill="#8A8A8A" />
                                <path d="M6.55 7.25C6.55 6.8634 6.8634 6.55 7.25 6.55H12.75C13.1366 6.55 13.45 6.8634 13.45 7.25C13.45 7.6366 13.1366 7.95 12.75 7.95H7.25C6.8634 7.95 6.55 7.6366 6.55 7.25Z" fill="#8A8A8A" />
                                <path d="M7 9.05C6.6134 9.05 6.3 9.3634 6.3 9.75C6.3 10.1366 6.6134 10.45 7 10.45H9.25C9.6366 10.45 9.95 10.1366 9.95 9.75C9.95 9.3634 9.6366 9.05 9.25 9.05H7Z" fill="#8A8A8A" />
                            </svg>
                            <Text variant="bodyMd" as="p" tone="subdued">{t("Turn ranking insights into traffic-driving content.")}</Text>
                        </div>
                        <div style={{ marginTop: '16px' }}><Button onClick={() => upgradeShow(2)} icon={LockIcon} variant="primary">{t("Upgrade to unlock")}</Button></div>
                    </div>
                    <div className="upgrade_panel_swiper">
                        <Swiper
                            slidesPerView={"auto"}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false
                            }}
                            modules={[Autoplay, S_Pagination, Navigation]}
                            pagination={{
                                clickable: true,
                            }}
                            touchRatio={0.5}
                            spaceBetween={10}
                            initialSlide={0}
                        >
                            <SwiperSlide key={0}>
                                <img src="/imgs/Image/kr-upgrade-1.png" alt="" />
                            </SwiperSlide>
                            <SwiperSlide key={1}>
                                <img src="/imgs/Image/kr-upgrade-2.png" alt="" />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div> : tableData.length === 0 ? <div className="kr-table-empty">
                    <img src="/imgs/Image/kr-empty.png" alt="" />
                    <Text variant="headingMd" as="h2" tone="subdued">{t("No Keywords Found")}</Text>
                </div> : <IndexTable
                    loading={listLoading}
                    resourceName={resourceName}
                    itemCount={userLevel === 1 ? testRowData.length : tableData.length}
                    selectedItemsCount={
                        allResourcesSelected ? "All" : selectedResources.length
                    }
                    onSelectionChange={handleSelectionChange}
                    headings={tableHeadings}
                    promotedBulkActions={promotedBulkActions}
                    selectable={userLevel !== 1}
                    sortable={[false, true, true, true, false, false]}
                    onSort={onSortColumnData}
                >
                    {userLevel === 1 ? testRowData : rowKeywordData}
                </IndexTable>
            }
            {
                Boolean(userLevel !== 1 && tableData.length > 0) && <div className={`justify_center ${current_PageSize > 5 ? 'sticky_footer' : ''}`}>
                    <Pagination
                        label={footerContentMsg}
                        hasPrevious={hasPrevious}
                        onPrevious={() => changePageTable(page - 1)}
                        hasNext={hasNext}
                        onNext={() => changePageTable(page + 1)}
                    />
                </div>
            }
        </Card>
    </div>

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终页面
    const pageContanier = <div className="keyword_pages">
        <BlockStack gap={400}>
            {domainBanner}
            {TipBanner}
            {PageTipBanner}
            {TopDataBlock}
            <BlockStack gap={200}>
                {TopicTableList}
            </BlockStack>
        </BlockStack>
        {FooterHelpBox}
    </div>

    return (
        <div className="mykeyword_pages">
            {
                (pageLoading || embedLoading) ? <SkeltonLoading /> : <Page>
                    <title>SEOWILL - Keyword Rank Tracker</title>

                    <div className="pageButton flex_layout">
                        <Popover
                            active={exportPopState}
                            activator={
                                userLevel === 1 ? <Button icon={LockIcon} disabled>{t("Export")}</Button> :
                                    <Button loading={exportLoading} onClick={(e) => {
                                        e && e.stopPropagation();
                                        setExportPopState(!exportPopState);
                                    }} disclosure>
                                        <div className="export_opera flex_layout">
                                            {t("Export")}
                                        </div>
                                    </Button>
                            }
                            onClose={() => setExportPopState(false)}
                            preferredAlignment="right"
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    {
                                        content: t("Export current keywords"),
                                        onAction: exportKeywordsData,
                                        disabled: tableData.length === 0
                                    },
                                    {
                                        content: t("Export history"),
                                        onAction: openExportHistory
                                    }
                                ]}
                            />
                        </Popover>
                    </div>
                    {pageContanier}
                    {exportRecordsModal}
                    {delSegmentsModal}
                    {creditsBuyModal}
                    {categoryManageModal}
                    {generatingTipModal}
                    <AddToSegments
                        type={"Keywords"}
                        level={userLevel}
                        openState={openState}
                        keywordsSelData={keywordsSelData}
                        toggleToast={toggleToast}
                        show={upgradeShow}
                        handleCloseModal={handleCloseCreateModal}
                        handleResetAll={handleResetAll}
                        handleCallbackData={handleCallbackData}
                    />
                </Page>
            }
        </div>
    );
}


function disambiguateLabel(key, selectVal, arr) {
    if (selectVal.length === 0) return key;
    switch (key) {
        case 'Topic':
            let topicArr = arr.filter(i => selectVal.includes(i.value));
            let topicText = '';
            topicArr.forEach((t, i) => {
                topicText += i === topicArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Topic: ${topicText}`;
        case 'KdDegree':
            let kdArr = arr.filter(i => selectVal.includes(i.value));
            let kdText = '';
            kdArr.forEach((t, i) => {
                kdText += i === kdArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `KD: ${kdText}`;
        case 'Covered':
            return `${t("Covered")}: ${t(selectVal[0])}`;
        case 'Segments':
            let segArr = arr.filter(i => selectVal.includes(i.value));
            let segText = '';
            segArr.forEach((t, i) => {
                segText += i === segArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Categories: ${segText}`;
        case 'Type':
            let typeArr = arr.filter(i => selectVal.includes(i.value));
            let typeText = '';
            typeArr.forEach((t, i) => {
                typeText += i === typeArr.length - 1 ? t.label : `${t.label}, `;
            })
            return `Type: ${typeText}`;
        default:
            return selectVal;
    }
}

function isEmpty(value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
}

// 单位转换
function formatNumber(num) {
    // 将数字转换为以K为单位
    return (typeof num === 'number' && !isNaN(num) && num >= 1000) ? (num / 1000).toFixed(1) + 'K' : num;
}

export default withRouter(KeywordsData);